import {admobOpmcAdapter} from './admobOpmc.ts';
import {inmobiAdapter} from './inmobi.ts';
import {pangleAdapter} from './pangle.ts';
import {vungleAdapter} from './vungle.ts';
import {registerWaterfallSource} from './registry.ts';

registerWaterfallSource(admobOpmcAdapter);
registerWaterfallSource(inmobiAdapter);
registerWaterfallSource(pangleAdapter);
registerWaterfallSource(vungleAdapter);
// AppLovin / Mintegral adapters remain exported below; re-enable with:
// import {applovinAdapter} from './applovin.ts';
// import {mintegralAdapter} from './mintegral.ts';
// registerWaterfallSource(applovinAdapter);
// registerWaterfallSource(mintegralAdapter);

export type {
    BuildConfirmStepsContext,
    BuildConfirmStepsResult,
    WaterfallSourceAdapter,
} from './types.ts';
export {admobOpmcAdapter} from './admobOpmc.ts';
export {inmobiAdapter, buildInmobiMappingChange, parseInmobiPlacementIdFromApplyData} from './inmobi.ts';
export {
    applovinAdapter,
    APPLOVIN_SDK_KEY_STORAGE,
    buildApplovinMappingChange,
    parseMaxAdUnitIdFromApplyData,
} from './applovin.ts';
export {
    mintegralAdapter,
    buildMintegralMappingChange,
    parseMintegralUnitIdFromApplyData,
} from './mintegral.ts';
export {
    pangleAdapter,
    buildPangleMappingChange,
    parsePanglePlacementIdFromApplyData,
} from './pangle.ts';
export {
    vungleAdapter,
    buildVungleMappingChange,
    parseVunglePlacementIdFromApplyData,
} from './vungle.ts';
export {
    APPLOVIN_SOURCE_ID,
    INMOBI_SOURCE_ID,
    MINTEGRAL_SOURCE_ID,
    PANGLE_SOURCE_ID,
    VUNGLE_SOURCE_ID,
    mappingChangeHasConfigs,
    maxAdFormat,
    mintegralAdType,
    pangleAdSlotType,
    resolveApplovinAdapter,
    resolveInmobiAdapter,
    resolveMintegralAdapter,
    resolvePangleAdapter,
    resolveVungleAdapter,
    vunglePlacementType,
} from './partnerAdapters.ts';
export {
    getWaterfallSource,
    isSupportedWaterfallSource,
    listSupportedSourceIds,
    registerWaterfallSource,
    resetWaterfallSourceRegistryForTests,
} from './registry.ts';
export {
    defaultSelectedPlatformIds,
    filterSupportedWaterfallOptions,
    pickDefaultSupportedWaterfallId,
    pickWaterfallIdAfterReload,
    unionSupportedPlatformOptions,
} from './options.ts';
